import history from "web/script/utils/history";
import environment from "web/script/modules/environment";
import { getLanguage } from "web/script/modules/language";
import { getURL } from "web/script/routing/getUrl";
import router from "./router";
import lystAppHandler from "./handlers/lyst-app-handler";
import searchHandler from "./handlers/search-handler";
import catchAllHandler from "./handlers/catch-all-handler";
import fullscreenGalleryHandler from "./handlers/fullscreen-gallery-handler";
import productOverlayHandler from "./handlers/product-overlay-handler";
import signupOverlayHandler from "./handlers/signup-overlay-handler";


export const DIGIT_REGEX = /^\d*$/;

let productPageRegex = null;
let productPageRegexLanguage = null;
export function getProductPageRegex() {
    if (productPageRegex === null || productPageRegexLanguage !== getLanguage()) {
        productPageRegex = new RegExp(getURL("productPageRegex"));
        productPageRegexLanguage = getLanguage();
    }
    return productPageRegex;
}

export function getSearchPageURL() {
    return `/${getURL("searchPage")}/`;
}

let searchPageRegex = null;
let searchPageRegexLanguage = null;
export function getSearchPageRegex() {
    if (searchPageRegex === null || searchPageRegexLanguage !== getLanguage()) {
        searchPageRegex = new RegExp(`^/?${getURL("searchPage")}/$`);
        searchPageRegexLanguage = getLanguage();
    }
    return searchPageRegex;
}

let signupPageRegex = null;
let signupPageRegexLanguage = null;
export function getSignupPageRegex() {
    if (signupPageRegex === null || signupPageRegexLanguage !== getLanguage()) {
        signupPageRegex = new RegExp(getURL("signupPageRegex"));
        signupPageRegexLanguage = getLanguage();
    }
    return signupPageRegex;
}

export function getRothkoEndpoint() {
    return getURL("rothkoEndpoint");
}

function setup() {
    history.on("change", (event, data) => {
        // get the uuid for this history entry
        const uuid = data.state.uuid;

        if (environment.hasState(uuid)) {
            // if we have some environment state saved under this uuid then load it
            environment.loadState(uuid);
        } else {
            // else create a new saved state under this uuid
            environment.saveState(uuid);
        }

        router.update(data.path, data.query);
    });

    router.map((match) => {
        match("/", {}, lystAppHandler, (match) => {
            match(getSearchPageRegex(), {}, searchHandler);

            match(getSignupPageRegex(), {}, signupOverlayHandler);

            match(getProductPageRegex(), {}, productOverlayHandler, (match) => {
                match(null, { product_gallery: DIGIT_REGEX }, fullscreenGalleryHandler);
            });

            match(".*", {}, catchAllHandler);
        });
    });

    history.start();
}

export default {
    setup: setup,
};
